var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-global"},[_c('div',{staticClass:"tw-text-lg tw-font-medium tw-border-b-4 tw-border-nj-primary tw-w-48 tw-text-gray-700"},[_vm._v("Login")])])
}]

export { render, staticRenderFns }